<script setup>
import { onBeforeUnmount, onBeforeMount, ref } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import axios from "axios";

import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import Swal from "sweetalert2";
const store = useStore();
const router = useRouter();
const body = document.getElementsByTagName("body")[0];

// 🌐 Local State
const username = ref("");
const password = ref("");
const loading = ref(false);

// 🎯 Lifecycle Hooks
onBeforeMount(() => {
  store.state.hideConfigButton = true;
  store.state.showNavbar = false;
  store.state.showSidenav = false;
  store.state.showFooter = false;
  body.classList.remove("bg-gray-100");

  // ล้าง token เดิมเมื่อเข้าสู่หน้าล็อกอิน
  localStorage.removeItem("token");
  localStorage.removeItem("role");
  localStorage.removeItem("lastActivity");
});

onBeforeUnmount(() => {
  store.state.hideConfigButton = false;
  store.state.showNavbar = true;
  store.state.showSidenav = true;
  store.state.showFooter = true;
  body.classList.add("bg-gray-100");
});

// 🧠 Login Function
const login = async () => {
  if (!username.value || !password.value) {
    Swal.fire("กรุณาระบุ username และ password");
    return;
  }

  loading.value = true;

  try {
    const response = await axios.post(
      "https://dashboard-api.linkstudio.io/api/v1/game/control/users/login",
      {
        username: username.value.toLowerCase(),
        password: password.value,
      }
    );

    const res = response.data;

    if (res.responseStatus.code !== 0) {
      Swal.fire({
        icon: "error",
        title: "เข้าสู่ระบบไม่สำเร็จ",
        text:
          res.responseStatus.message ||
          "Username หรือ Password ไม่ถูกต้อง",
      });
      loading.value = false;
      return;
    }

    // ✅ Save token & role
    localStorage.setItem("token", res.data.token);
    localStorage.setItem("username", res.data.username);
    localStorage.setItem("lastActivity", Date.now().toString());

    Swal.fire("เข้าสู่ระบบสำเร็จ");
    router.push("/dashboard-default");
  } catch (e) {
    console.error("Login error:", e);
    Swal.fire({
      icon: "error",
      title: "เกิดข้อผิดพลาด",
      text: e.response?.data?.responseStatus?.message || e.message,
    });
  } finally {
    loading.value = false;
  }
};
</script>

<template>
  <div class="container top-0 position-sticky z-index-sticky">
    <div class="row">
      <div class="col-12"></div>
    </div>
  </div>

  <main class="mt-0 main-content">
    <section>
      <div class="page-header min-vh-100">
        <div class="container">
          <div class="row justify-content-center">
            <div
              class="mx-auto col-xl-4 col-lg-5 col-md-7 d-flex flex-column mx-lg-0"
            >
              <div class="card card-plain">
                <div class="pb-0 card-header text-start">
                  <h4 class="font-weight-bolder">Sign In</h4>
                  <p class="mb-0">Enter your username and password to sign in</p>
                </div>

                <div class="card-body">
                  <form role="form" @submit.prevent="login">
                    <div class="mb-3">
                      <argon-input
                        id="username"
                        type="text"
                        placeholder="Username"
                        name="username"
                        v-model="username"
                        size="lg"
                      />
                    </div>

                    <div class="mb-3">
                      <argon-input
                        id="password"
                        type="password"
                        placeholder="Password"
                        name="password"
                        v-model="password"
                        size="lg"
                      />
                    </div>

                    <div class="text-center">
                      <argon-button
                        class="mt-4"
                        variant="gradient"
                        color="success"
                        fullWidth
                        size="lg"
                        :disabled="loading"
                        type="submit"
                      >
                        <template v-if="loading">
                          <span
                            class="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Loading...
                        </template>
                        <template v-else>
                          Sign in
                        </template>
                      </argon-button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<style scoped>
/* Add any custom styles if needed */
</style>
